"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.8125 40.2708C17.5991 40.2723 17.3876 40.2306 17.1907 40.1483C16.9938 40.0659 16.8155 39.9446 16.6667 39.7916C16.5089 39.6454 16.3831 39.4681 16.297 39.2709C16.2109 39.0738 16.1665 38.8609 16.1665 38.6458C16.1665 38.4307 16.2109 38.2178 16.297 38.0207C16.3831 37.8235 16.5089 37.6462 16.6667 37.5L29.8542 25L16.6667 12.5C16.4534 12.2073 16.3484 11.8497 16.3695 11.4882C16.3907 11.1267 16.5368 10.7837 16.7829 10.518C17.0289 10.2523 17.3596 10.0803 17.7184 10.0314C18.0772 9.98251 18.4419 10.0598 18.75 10.25L33.3334 23.875C33.4846 24.0207 33.6049 24.1955 33.687 24.3888C33.7692 24.5821 33.8115 24.7899 33.8115 25C33.8115 25.21 33.7692 25.4179 33.687 25.6112C33.6049 25.8045 33.4846 25.9792 33.3334 26.125L18.9584 39.8333C18.8068 39.9797 18.6271 40.094 18.4302 40.1692C18.2333 40.2444 18.0232 40.2789 17.8125 40.2708Z",
    fill: fill
  }));
};

exports["default"] = _default;